import AnimateOnEntry from './AnimateOnEntry';
import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.binder(Hooks.AnimateOnEntry, AnimateOnEntry);
